import { withViewModel } from '../../../../../../../../../../infrastructure/components/with-view-model';
import { IAccountOrganizationDTO } from '../../../../../../../../../../api/account-organizations.dao';
import { SpeakerOrganizationFormVM } from './speaker-organization-form.viewmodel';
import { SpeakerOrganizationFormPresentation } from './speaker-organization-form-presentation';

interface ISpeakerOrganizationFormContainerProps {
    accountId: number;
    existingOrganizationNames: string[];
    anchorElement: HTMLDivElement | null;
    onOrganizationCreated: (organization: IAccountOrganizationDTO) => void;
    onCancel: () => void;
}

const SpeakerOrganizationFormContainer = withViewModel(
    SpeakerOrganizationFormPresentation,
    (props: ISpeakerOrganizationFormContainerProps) => new SpeakerOrganizationFormVM(
        props.accountId,
        props.existingOrganizationNames,
        props.anchorElement,
        props.onOrganizationCreated,
        props.onCancel,
    ),
    () => []
);

export { SpeakerOrganizationFormContainer as SpeakerOrganizationForm };